import { Box, FlexBox } from "../../components/primitives";
import { styled } from "../../stitches.config";

export const BannerWarning = styled(FlexBox, {
  height: 60,
  background: "red",
  color: "white",
  justifyContent: "center",
  alignItems: "center",
  fontSize: 20,
});

export const SideMenuWrapper = styled(Box, {
  width: 250,
  borderRight: "1px solid #cbd5e1",
  minHeight: "100vh",
  backgroundColor: "#f8f8ff",
  "@smRev": {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    zIndex: 10000,
  },
});
